const B2BTheme = () => {
  return {
    Favorite: {
      themeProps: {
        hideCount: true,
        showOverlay: true,
        showPlusSign: true
      }
    },
    AddToList: {
      themeProps: {
        hideCount: true,
        showPlusSign: true
      }
    },
    ListFormsSettingsForm: {
      themeProps: {
        showShareList: true,
        hidePrivacyToggle: true
      }
    },
    ProductListHeader: {
      themeProps: {
        hideActionButtons: true,
      }
    },
    ProductListHeaderMobile: {
      themeProps: {
        showATC: true,
      }
    },
    ListTileMobile: {
      themeProps: {
        showShareList: true,
      }
    },
    CreateAListForm: {
      themeProps: {
        showShareList: true,
        hidePrivacyToggle: true
      }
    },
    PackagePriceSuite: {
      themeProps: {
        hideFinancingOffer: true
      }
    },
    ProductInfoBar: {
      themeProps: {
        showUpcCode: true
      }
    },
    ProductList: {
      themeProps: {
        showListView: true,
        showATQ: true,
        showSaveSharedListBanner: true
      }
    },
    ProductListNotFoundMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    ProductListEmptyListMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    ProductOverview: {
      themeProps: {
        showUpcCode: true
      }
    },
    ProductPodDefault: {
      themeProps: {
        showModelNumber: true,
        showSkuNumber: true,
      }
    },
    UserListsEmptyMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    UserListsEmptyMessagingPhp: {
      themeProps: {
        showListIcon: true
      }
    },
    NeedHelp: {
      themeProps: {
        hideCustomerSupport: true,
        hideCallTimings: true,
        showDefaultHelpText: true,
        showCustomerSupport: false,
        showCustomerBlinds: true,
        showSchedule: false,
        showDefaultSupportSms: false
      }
    },
    PaymentEstimatorContainer: {
      themeProps: {
        hidePaymentEstimatorMobile: true,
      }
    },
    ProductPage: {
      themeProps: {
        hideAddToList: true
      }
    },
    ProductPageMobile: {
      themeProps: {
        hideAddToList: true
      }
    },
    CustomProductPod: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    CustomProductPodMobile: {
      themeProps: {
        hideAddToListButton: false
      }
    },
    CustomProductPodResponsive: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    CustomProductPodTwoByTwoColumn: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    ConfirmationEmails: {
      themeProps: {
        showEmailConfirm: true
      }
    },
    CartInfoSection: {
      themeProps: {
        hideQuickAddLink: false,
        hideRemoveAllLink: true
      }
    },
    EmptyCart: {
      themeProps: {
        hideQuickAddLink: false,
      }
    },
    RightRail: {
      themeProps: {
        hidePurchaseOrderSection: false
      }
    },
  }
};

export const EPRTheme = () => {
  return {
    ...B2BTheme(),
    StoreSearch: {
      themeProps: {
        hideStoreSearchFeatures: true,
        hideSponsoredCarousel: true,
        hideSponsoredBanner: true
      }
    },
    StoreLocator: {
      themeProps: {
        hideStoreSearchFeatures: true,
        hideSponsoredCarousel: true,
        hideSponsoredBanner: true
      }
    },
    DashboardPageContent: {
      themeProps: {
        hideDashboardAccountDetails: true,
        hideDashboardPlanYourJobs: false,
        hideDashboardRecentActivity: true,
      },
    },
    DashboardRecentActivity: {
      themeProps: {
        hideLoyaltyBenefits: true,
        hideProductList: true,
        hideMoreProXtraBenefits: true,
        hideStoreDetails: true
      }
    },
    DashboardPlanYourJobs: {
      themeProps: {
        hideJobQuotesCard: true
      }
    },
    EmptyCart: {
      themeProps: {
        hideQuickAddContainer: false,
        showSignedInButtons: true,
        hideSaveForLaterContainer: true
      }
    },
    FulfillmentPodShipping: {
      themeProps: {
        hideFasterDelivery: true,
        hideDeliveryEta: true
      }
    },
    DefaultShipping: {
      themeProps: {
        hideDeliveryEta: true,
        hideFasterDelivery: true
      }
    },
    NeedHelp: {
      themeProps: {
        showDefaultHelpText: false,
        isStorefront: true,
        showCustomerSupport: false,
        showCustomerBlinds: false,
        showSchedule: false,
        showDefaultSupportSms: false
      }
    },
    QuickAddContainer: {
      themeProps: {
        hideQuickAdd: false,
      }
    },
    CartInfoSection: {
      themeProps: {
        hidePaymentEstimatorContainer: true,
        hideShareCart: true,
        hideQuickAddLink: false,
        hideCheckoutButton: true,
        displayStorefrontWarning: true,
        hideRemoveAllLink: true,

      }
    },
    RecommendationsSection: {
      themeProps: {
        hideSponsoredCarousel: true,
        hideInspiredByRecentViews: false,
        hideCustomerAlsoPurchased: false,
        hideEndcapTopSavings: true,
        hideBrandBasedCollections: true
      }
    },
    MainCheckoutContainer: {
      themeProps: {
        hideNeedHelpMessage: false
      }
    },
    RightRail: {
      themeProps: {
        hidePaypalCheckoutButtonContainer: true,
        hidePromoCode: true,
        hideSubmitForApprovalButton: false,
        hideCheckoutButton: true,
        hidePricesDisclaimer: false,
        hideDeliveryFeesMessage: true,
        hidePurchaseOrderSection: false,
        hidePurchaseOrderNumber: false,
        hideCreateAQuote: true,
        hideInstantCheckoutCart: true,
        hideQuickPayPayments: true,
        hideTaxExempt: true
      }
    },
    MainCartContainer: {
      themeProps: {
        hideReturnPolicy: true,
        hideDynamicDiscount: true,
        hideNeedHelp: true,
        hideSaveForLaterContainer: true
      }
    },
    OrderSummary: {
      themeProps: {
        hideSalesTax: true,
        showEstimatedLabel: true
      }
    },
    BuyItAgain: {
      themeProps: {
        timeFrameDefault: 'YESTERDAY',
      }
    },
    BuyItAgainGridViewPod: {
      themeProps: {
        hideAddToQuoteButton: true,
      }
    },
    BuyItAgainPodMobile: {
      themeProps: {
        hideAddToQuoteButton: true,
      }
    },
    BuyItAgainListViewPod: {
      themeProps: {
        hideAddToQuoteButton: true,
      }
    },
    CustomerAccountNavigation: {
      themeProps: {
        isStoreFront: true,
      }
    },
    ProductPage: {
      themeProps: {
        hideConsumerCardMessaging: true,
        hideReturnsMessaging: true,
        hideSponsoredCarousel: true,
        hideSponsoredPipBanner: true,
        hideShareBeltShareButton: true,
        hideCustomSize: true,
        hideHdhomeSignup: true,
      }
    },
    ProductPageMobile: {
      themeProps: {
        hideConsumerCardMessaging: true,
        hideReturnsMessaging: true,
        hideSponsoredCarousel: true,
        hideShareBeltShareButton: true,
        hideCustomSize: true,
        hideHdhomeSignup: true,
      }
    },
    PaintReorderPage: {
      themeProps: {
        hideHdhomeSignup: true,
      }
    },
    PaintReorderPageMobile: {
      themeProps: {
        hideHdhomeSignup: true,
      }
    },
    BuyboxActions: {
      themeProps: {
        hideAddToQuoteButton: true,
        hidePaypal: true,
      }
    },
    MajorApplianceBuyBox: {
      themeProps: {
        hidePaypal: true
      }
    },
    ProductList: {
      themeProps: {
        showListView: true,
        showATQ: false,
        showSaveSharedListBanner: true
      }
    },
    CartProductAddons: {
      themeProps: {
        allowSubscriptionAddOn: false,
        allowHomeDepotProtectionPlanAddOn: true,
        allowAssemblyAddOn: false,
        allowFreeAssemblyAtStoreAddOn: true,
        allowProInstallAddOn: false
      }
    },
    CartItemActions: {
      themeProps: {
        hideSaveForLater: true,
        disableAddToListSignInRedirect: true
      }
    },
    CartItemList: {
      themeProps: {
        showHeaderSections: true
      }
    },
    FulfillmentTiles: {
      themeProps: {
        hideDeliveryMessageUnderTile: true
      }
    },
    AddToExistingList: {
      themeProps: {
        disableSignInDrawer: true
      }
    },
    ListFormsMainMenuDrawerBody: {
      themeProps: {
        hideShareList: true
      }
    },
    CustomProductPod: {
      themeProps: {
        productIdentifierTypes: [
          "model",
          "storeSku",
          "itemId"
        ],
        showProductQuantity: true,
        showAddToListButton: true,
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    CustomProductPodMobile: {
      themeProps: {
        productIdentifierTypes: [
          "model",
          "storeSku",
          "itemId"
        ],
        showProductQuantity: true,
        showAddToListButton: true,
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    CustomProductPodResponsive: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    CustomProductPodTwoByTwoColumn: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: false
      }
    },
    BrowseAndSearchPage: {
      themeProps: {
        hideSponsoredCarousel: true,
        hideSponsoredBanner: true,
        hideSponsoredSkyscraperBanner: true,
        hideHdhomeSignup: true,
      }
    },
    BrowseAndSearchPageMobile: {
      themeProps: {
        hideSponsoredCarousel: true,
        hideSponsoredBanner: true,
        hideSponsoredSkyscraperBanner: true,
        hideHdhomeSignup: true,
      }
    },
    PepPage: {
      themeProps: {
        hideSponsoredCarousel: true,
        hideHdhomeSignup: true,
      }
    },
    PepMobilePage: {
      themeProps: {
        hideHdhomeSignup: true,
      }
    },
    AddToCartConfirmation: {
      themeProps: {
        disableCheckout: true,
        hideConsumerCardMessaging: true
      }
    },
    ReorderRecommendations: {
      themeProps: {
        showStorefrontFallback: true
      }
    },
    BundlePage: {
      themeProps: {
        hideShareBeltShareButton: true,
      },
    },
    PIPSharebelt: {
      themeProps: {
        hideShareBeltShareButton: true,
      },
    },
    DeliveryDrawer: {
      themeProps: {
        showDeliveryEst: false,
      },
    },
    CartMobileCheckoutFooter: {
      themeProps: {
        hidePaypalCheckoutButtonContainer: true,
        hideSubmitForApprovalButton: false,
        hideCheckoutButton: true,
      }
    },
    ProductAddOns: {
      themeProps: {
        hideExpertInHome: true,
        hideProductAddOns: true,
        themeHideProReferral: true,
        showHomeInstallation: false,
      }
    },
    PlccRightRail: {
      themeProps: {
        hidePLCCRightRailMessage: true,
      }
    },
    PayPalMessage: {
      themeProps: {
        hidePaypal: true
      }
    },
    ConfirmationEmails: {
      themeProps: {
        showEmailConfirm: false
      }
    },
    StorePickupBody: {
      themeProps: {
        hideCurbsidePickup: true,
        defaultPickupOption: 'INSTORE'
      }
    },
    Buybox: {
      themeProps: {
        hideSubscribeandSave: true,
      }
    },
    ApplianceBody: {
      themeProps: {
        hideDriverInstructions: true,
        hideCalendar: true
      }
    },
    DeliveryOptionsBody: {
      themeProps: {
        hideDeliveryOptions: true,
        hideScheduledDelivery: true
      }
    },
    DeliveryOptionsSummary: {
      themeProps: {
        hideDeliveryOptionDetails: true,
      }
    },
    StorePickupItem: {
      themeProps: {
        hideStorePickupItemSummary: true,
      }
    },
    ProtectionPlanRadioBtns: {
        themeProps: {
            defaultDeclineCoverage: true,
        }
    },
      PartsAndServicesProvider: {
        themeProps: {
          defaultDeclineCoverage: true,
          defaultDeclineInstall: true
        }
    }
  }
};

export const ExchangeTheme = () => {
  return {
    ...B2BTheme(),
    ApplCheckAvailTotal: {
      themeProps: {
        hideTaxMessaging: true
      }
    },
    AddToCartConfirmation: {
      themeProps: {
        disableCheckout: false,
        hideConsumerCardMessaging: true
      }
    },
    Totals: {
      themeProps: {
        hideTaxMessaging: true,
      }
    },
    CartActions: {
      themeProps: {
        hidePaypalButton: true
      }
    },
    FBTCustomProductPod: {
      themeProps: {
        hideAddToList: true
      }
    },
    RecsProductPod: {
      themeProps: {
        hideAddToList: true
      }
    },
    FbrProductPod: {
      themeProps: {
        hideAddToList: true
      }
    },
    MainCartContainer: {
      themeProps: {
        hideDynamicDiscount: true,
        hideSaveForLaterContainer: true,
        hideFAQNativeApp: true,
        hidePaymentEstimatorContainer: true
      }
    },
    CartInfoSection: {
      themeProps: {
        hidePaymentEstimatorContainer: true,
        hideQuickAddLink: true,
        hideShareCart: true,
      }
    },
    QuickAddContainer: {
      themeProps: {
        hideQuickAdd: false,
      }
    },
    CartItemList: {
      themeProps: {
        showHeaderSections: true,
        hideBulkFulfillmentOptions: true
      }
    },
    RightRail: {
      themeProps: {
        hidePurchaseOrderSection: true,
        hidePaypalCheckoutButtonContainer: true,
        hideInstantCheckoutCart: true,
        hideQuickPayPayments: true
      }
    },
    EmptyCart: {
      themeProps: {
        hideQuickAddContainer: false,
        showSignedInButtons: true,
        hideSaveForLaterContainer: true,
        hideProductsText: true,
        hideQuickAddLink: true,
      }
    },
    NeedHelp: {
      themeProps: {
        hideCustomerSupport: false,
        hideCustomBlinds: true,
        hideCallTimings: false,
        showDefaultHelpText: true,
        showCustomerSupport: true,
        showCustomerBlinds: false,
        showSchedule: true,
        showDefaultSupportSms: true
      }
    },
    CartMobileCheckoutFooter: {
      themeProps: {
        hidePaypalCheckoutButtonContainer: true,
      }
    },
    CartFulfillmentGroup: {
      themeProps: {
        hideSaveAllListLink: true,
        hideGroupMessages: true,
      }
    },
    FulfillmentPodShipping: {
      themeProps: {
        hideFasterDelivery: true,
        hideDeliveryEta: false
      }
    },
    DefaultShipping: {
      themeProps: {
        hideDeliveryEta: false,
        hideFasterDelivery: true
      }
    },
    PaymentEstimatorContainer: {
      themeProps: {
        hidePaymentEstimatorMobile: true,
      }
    },
    ProductPage: {
      themeProps: {
        hideConsumerCardMessaging: true,
        hideAddToList: true,
        hideAisleBay: true,
        hideYouMightAlsoNeed: true,
        hideSponsoredCarousel: true,
        hideRelatedProducts: true
      }
    },
    ProductPageMobile: {
      themeProps: {
        hideConsumerCardMessaging: true,
        hideAddToList: true,
        hideAisleBay: true,
        hideYouMightAlsoNeed: true,
        hideSponsoredCarousel: true,
        hideRelatedProducts: true
      }
    },
    SpecialBuyProductPod: {
      themeProps: {
        hideAddToList: true,
        hidePickupFulfillment: true
      }
    },
    SelectedItemDetails: {
      themeProps: {
        hideAddToList: true,
      }
    },
    CustomProductPod: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: true,
        hidePickupFulfillment: true
      }
    },
    CustomProductPodMobile: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: true,
        hidePickupFulfillment: true
      }
    },
    BuyboxActions: {
      themeProps: {
        hideAddToQuoteButton: true,
        hidePaypal: true
      }
    },
    MajorApplianceBuyBox: {
      themeProps: {
        hidePaypal: true
      }
    },
    EducationalLayoutRenderer: {
      themeProps: {
        hideInternalMarketingBanners: true
      }
    },
    FlexibleLayoutRenderer: {
      themeProps: {
        hideInternalMarketingBanners: true
      }
    },
    InspirationalLayoutRenderer: {
      themeProps: {
        hideInternalMarketingBanners: true
      }
    },
    NavigationalLayoutRenderer: {
      themeProps: {
        hideInternalMarketingBanners: true
      }
    },
    PlccRightRail: {
      themeProps: {
        hidePLCCRightRailMessage: true,
      }
    },
    CustomProductPodResponsive: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: true,
        hidePickupFulfillment: true
      }
    },
    BrowseAndSearchPage: {
      themeProps: {
        hideFFMFilters: true,
        hideEmailPromo: true,
        hideFeedback: true,
      }
    },
    BrowseAndSearchPageMobile: {
      themeProps: {
        hideFFMFilters: true,
        hideEmailPromo: true,
      }
    },
    CustomProductPodTwoByTwoColumn: {
      themeProps: {
        hideAddToListIcon: true,
        hideAddToListButton: true
      }
    },
    FulfillmentTiles: {
      themeProps: {
        hidePickupTileHeader: true,
        hideCheckNearbyStoresLink: true
      }
    },
    ProductAddOns: {
      themeProps: {
        hideAttachLabor: true,
        hideProductAddOns: true
      }
    },
    CartProductAddons: {
      themeProps: {
        allowInstallAddOn: false,
        allowProInstallAddOn: false,
        allowSubscriptionAddOn: false,
        allowAssemblyAddOn: false
      }
    },
    Buybox: {
      themeProps: {
        hideSubscribeandSave: true,
      }
    },
    useZipCode: {
      themeProps: {
        showDeliveryErrorMsg: true
      }
    },
    RecommendationsSection: {
      themeProps: {
        hideCustomerAlsoPurchased: true,
        hideBrandBasedCollections: true
      }
    },
    TrackOrderForm: {
      themeProps: {
        hideOrderSignIn: true
      }
    },
    ResultsWrapped: {
      themeProps: {
        showHomePageButton: true,
        noProductResultsMessage: "Sorry, this item is not available through this site. Please return to the home page and continue shopping."
      }
    },
    NotifyMe: {
      themeProps: {
        showTrackOutOfStock: false
      }
    },
    Promotion: {
      themeProps: {
        hideShortDesc: true,
        hideSpecialBuyLink: true
      }
    },
    VisualCategoryNavigation: {
      themeProps: {
        hideVizNav: true
      }
    },
    ResultsApplied: {
      themeProps: {
        hideResultsApplied: true
      }
    },
    QuickViewDetails: {
      themeProps: {
        showFavoriteIcon: false
      }
    },
    ShareBelt: {
      themeProps: {
        showAddToList: false
      }
    },
    ConsumerCardMessaging: {
      themeProps: {
        showHDCC: false
      }
    },
    PackagePod: {
      themeProps: {
        showAddToList: false
      }
    }
  }
};

export default B2BTheme;
